const receptionHallRoute = [
  // 接单大厅
  {
    path: "/reception",
    name: "Reception",
    component: () => import("@/views/receptionHall/index.vue"),
    redirect: "/reception/receptionhall",
    children: [
      {
        path: "/receptionhall",
        name: "ReceptionHall",
        meta: {
          activeName: "ReceptionHall",
        },
        component: () => import("@/views/receptionHall/receptionHall.vue"),
      },
      {
        path: "/detail",
        name: "ReceptionDetail",
        meta: {
          activeName: "ReceptionHall",
        },
        component: () => import("@/views/receptionHall/receptionDetail.vue"),
      },
    ],
  },
];

export default receptionHallRoute;
